/* eslint-disable import/no-default-export */
import Chance from 'chance';
const chance = new Chance();

export default chance.pickone([
  {
    id: '1',
    description: 'Australia (+61)',
    countryCallingCode: '+61',
  },
  {
    id: '159',
    description: 'New Zealand (+64)',
    countryCallingCode: '+64',
  },
  null,
]);
